"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TimePicker", {
  enumerable: true,
  get: function get() {
    return _TimePicker.default;
  }
});

require("./index.css");

var _TimePicker = _interopRequireDefault(require("./TimePicker"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line no-extend-native
Date.prototype.format = function (format) {
  var hour = this.getHours() < 10 ? "0" + this.getHours() : this.getHours();
  var minute = this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes();
  var second = this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds();

  switch (format) {
    case "HH:mm":
      return hour + ":" + minute;

    case "h:mm a":
      return hour % 12 + ":" + minute + " " + (this.getHours() < 12 ? "am" : "pm");

    case "h:mm:ss a":
      return hour % 12 + ":" + minute + ":" + second + " " + (this.getHours() < 12 ? "am" : "pm");

    default:
      return hour + ":" + minute + ":" + second;
  }
}; // eslint-disable-next-line no-extend-native


Date.prototype.clone = function () {
  return new Date(this.getTime());
};